import { AVIS_INICIALITZAR, AVIS_INTRODUCCIO_MODIFICAR_VALOR, AVIS_INTRODUCCIO_INICIALITZAR_VALORS,
    AVIS_OMPLIR_FORMULARI_AMB_UN_AVIS } from '../../../../actions/actionTypes';

let ESTAT_INICIAL = {};

/**
 * Fa una copia del objecte estat i elimina el atribut especificat per parametre
 * @param estat
 * @param idCamp {String}
 * @returns {*}
 */
const eliminarCampSenseValor = (estat, atributAEliminar) => {
    let nouEstat = Object.assign({}, estat);
    delete nouEstat[atributAEliminar];

    return nouEstat;
};

/**
 * Retorna True si el atribut "valor" es diferent de '', null o undefined. Pels altres casos
 * retorna False.
 * @param valor
 * @returns {boolean}
 */
const esValorInvalid = (valor) => {
    return valor === '' || valor === undefined || valor === null;
};

/**
 * Transforma un array de tipus [ {clau: valor}, {clau2: valor2}] a un objecte
 * del tipus {clau: valor, clau2: valor2}
 * @param valorsArray {Array}
 * @returns {Object}
 */
const transformacioValorsArrayAValorsObjecte = (valorsArray) => {
    var valorsObjecte = {};
    valorsArray.forEach((valorActual) => {
        var idCamp = Object.keys(valorActual)[0];
        valorsObjecte[idCamp] = valorActual[idCamp];
    });
    return valorsObjecte;
};

const campsFormulari = (state = ESTAT_INICIAL, action) => {

    switch (action.type) {
        case AVIS_INTRODUCCIO_MODIFICAR_VALOR: {
            const idCamp = action.idCamp;
            const valor = action.valor;

            //Si no te valor s'elimina el camp de la llista
            if (esValorInvalid(valor)) {
                return eliminarCampSenseValor(state, idCamp);
            }

            return {...state, [idCamp]: valor};
        }

        case AVIS_INICIALITZAR:
        case AVIS_INTRODUCCIO_INICIALITZAR_VALORS:
            return ESTAT_INICIAL;

        case AVIS_OMPLIR_FORMULARI_AMB_UN_AVIS: {
            const valorsArray = action.avis.valors;
            return transformacioValorsArrayAValorsObjecte(valorsArray);
        }

        default:
            return state;
    }
};

export default campsFormulari;



// WEBPACK FOOTER //
// ./src/reducers/avis/formulari/dades/valors.js